import { icons, IconType } from "@src/utils/icon";
// import "./icon.module.scss";

interface IconProps {
  iconName: IconType;
}

const Icon = ({ iconName }: IconProps) => {
  return <>{icons[iconName]}</>;
};

export default Icon;
